/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfPaymentPlanResponse } from '../model';
// @ts-ignore
import { ApiResponseOfPaymentPlanResponse } from '../model';
// @ts-ignore
import { ApiResponseOfPaymentPlanResponseArray } from '../model';
// @ts-ignore
import { ApiResponseOfPlanTierResponseArray } from '../model';
// @ts-ignore
import { PaymentPlanBody } from '../model';
/**
 * PaymentPlansApi - axios parameter creator
 * @export
 */
export const PaymentPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/paymentPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves payment plans one page at a time, with optional keyword, promo group, device and country filters applied by the Promotions API.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [text] Filter by plan name or code/SKU (case-insensitive partial match)
         * @param {string} [promoGroup] Filter by promo group (exact match)
         * @param {string} [device] Filter by device (exact match, case-insensitive)
         * @param {string} [country] Filter by country (exact match, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, text?: string, promoGroup?: string, device?: string, country?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/paymentPlans/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }

            if (promoGroup !== undefined) {
                localVarQueryParameter['promoGroup'] = promoGroup;
            }

            if (device !== undefined) {
                localVarQueryParameter['device'] = device;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanTiers: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/paymentPlans/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestPlans: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/paymentPlans/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentPlanCode 
         * @param {PaymentPlanBody} paymentPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (paymentPlanCode: string, paymentPlanBody: PaymentPlanBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentPlanCode' is not null or undefined
            assertParamExists('update', 'paymentPlanCode', paymentPlanCode)
            // verify required parameter 'paymentPlanBody' is not null or undefined
            assertParamExists('update', 'paymentPlanBody', paymentPlanBody)
            const localVarPath = `/api/v1/paymentPlans/{paymentPlanCode}`
                .replace(`{${"paymentPlanCode"}}`, encodeURIComponent(String(paymentPlanCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentPlanBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentPlansApi - functional programming interface
 * @export
 */
export const PaymentPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPaymentPlanResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves payment plans one page at a time, with optional keyword, promo group, device and country filters applied by the Promotions API.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [text] Filter by plan name or code/SKU (case-insensitive partial match)
         * @param {string} [promoGroup] Filter by promo group (exact match)
         * @param {string} [device] Filter by device (exact match, case-insensitive)
         * @param {string} [country] Filter by country (exact match, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, text?: string, promoGroup?: string, device?: string, country?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfPaymentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, text, promoGroup, device, country, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanTiers(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlanTierResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanTiers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestPlans(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} paymentPlanCode 
         * @param {PaymentPlanBody} paymentPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(paymentPlanCode: string, paymentPlanBody: PaymentPlanBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPaymentPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(paymentPlanCode, paymentPlanBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentPlansApi - factory interface
 * @export
 */
export const PaymentPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentPlansApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<ApiResponseOfPaymentPlanResponseArray> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves payment plans one page at a time, with optional keyword, promo group, device and country filters applied by the Promotions API.
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [text] Filter by plan name or code/SKU (case-insensitive partial match)
         * @param {string} [promoGroup] Filter by promo group (exact match)
         * @param {string} [device] Filter by device (exact match, case-insensitive)
         * @param {string} [country] Filter by country (exact match, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, text?: string, promoGroup?: string, device?: string, country?: string, options?: any): AxiosPromise<ApiPaginatedResponseOfPaymentPlanResponse> {
            return localVarFp.getPaginated(limit, page, text, promoGroup, device, country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanTiers(options?: any): AxiosPromise<ApiResponseOfPlanTierResponseArray> {
            return localVarFp.getPlanTiers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestPlans(options?: any): AxiosPromise<void> {
            return localVarFp.ingestPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentPlanCode 
         * @param {PaymentPlanBody} paymentPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(paymentPlanCode: string, paymentPlanBody: PaymentPlanBody, options?: any): AxiosPromise<ApiResponseOfPaymentPlanResponse> {
            return localVarFp.update(paymentPlanCode, paymentPlanBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentPlansApi - interface
 * @export
 * @interface PaymentPlansApi
 */
export interface PaymentPlansApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getAll(options?: any): AxiosPromise<ApiResponseOfPaymentPlanResponseArray>;

    /**
     * Retrieves payment plans one page at a time, with optional keyword, promo group, device and country filters applied by the Promotions API.
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [text] Filter by plan name or code/SKU (case-insensitive partial match)
     * @param {string} [promoGroup] Filter by promo group (exact match)
     * @param {string} [device] Filter by device (exact match, case-insensitive)
     * @param {string} [country] Filter by country (exact match, case-insensitive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getPaginated(limit?: number, page?: number, text?: string, promoGroup?: string, device?: string, country?: string, options?: any): AxiosPromise<ApiPaginatedResponseOfPaymentPlanResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getPlanTiers(options?: any): AxiosPromise<ApiResponseOfPlanTierResponseArray>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    ingestPlans(options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} paymentPlanCode 
     * @param {PaymentPlanBody} paymentPlanBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    update(paymentPlanCode: string, paymentPlanBody: PaymentPlanBody, options?: any): AxiosPromise<ApiResponseOfPaymentPlanResponse>;

}

/**
 * PaymentPlansApi - object-oriented interface
 * @export
 * @class PaymentPlansApi
 * @extends {BaseAPI}
 */
export class PaymentPlansApi extends BaseAPI implements PaymentPlansApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getAll(options?: any) {
        return PaymentPlansApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves payment plans one page at a time, with optional keyword, promo group, device and country filters applied by the Promotions API.
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [text] Filter by plan name or code/SKU (case-insensitive partial match)
     * @param {string} [promoGroup] Filter by promo group (exact match)
     * @param {string} [device] Filter by device (exact match, case-insensitive)
     * @param {string} [country] Filter by country (exact match, case-insensitive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getPaginated(limit?: number, page?: number, text?: string, promoGroup?: string, device?: string, country?: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).getPaginated(limit, page, text, promoGroup, device, country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getPlanTiers(options?: any) {
        return PaymentPlansApiFp(this.configuration).getPlanTiers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public ingestPlans(options?: any) {
        return PaymentPlansApiFp(this.configuration).ingestPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentPlanCode 
     * @param {PaymentPlanBody} paymentPlanBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public update(paymentPlanCode: string, paymentPlanBody: PaymentPlanBody, options?: any) {
        return PaymentPlansApiFp(this.configuration).update(paymentPlanCode, paymentPlanBody, options).then((request) => request(this.axios, this.basePath));
    }
}
